import { render, staticRenderFns } from "./EditTeacherView.vue?vue&type=template&id=25d24b63&scoped=true&"
import script from "./EditTeacherView.vue?vue&type=script&lang=js&"
export * from "./EditTeacherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d24b63",
  null
  
)

export default component.exports